import api from './api'

const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5 MB

export const createLesson = async (lessonName, fileDisplayName, file, isAbsorbCourse = false, absorbCourseId = '', passingScore = 80, content = null) => {
  if (file) {
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`File size exceeds maximum of ${MAX_FILE_SIZE / (1024 * 1024)} MB`)
    }
    if (!file.name.toLowerCase().endsWith('.md')) {
      throw new Error('Only .md files are allowed')
    }
  }
  
  const formData = new FormData()
  formData.append('lessonName', lessonName)
  formData.append('fileDisplayName', fileDisplayName)
  if (file) {
    formData.append('file', file)
  }
  if (content) {
    formData.append('content', content)
  }
  formData.append('isAbsorbCourse', isAbsorbCourse)
  if (isAbsorbCourse && absorbCourseId) {
    formData.append('absorbCourseId', absorbCourseId)
  }
  if (isAbsorbCourse) {
    formData.append('passingScore', passingScore)
  }
  
  const response = await api.post('/api/lessons', formData)
  
  return response.data
}

export const listLessons = async (search = '', limit = 100) => {
  const response = await api.get('/api/lessons', {
    params: { search, limit }
  })
  return response.data
}

export const getLessonFile = async (lessonKey) => {
  const response = await api.get(`/api/lessons/${lessonKey}/file`, {
    responseType: 'blob'
  })
  return response.data
}

export const getLessonContent = async (lessonKey) => {
  const response = await api.get(`/api/lessons/${lessonKey}/file`, {
    responseType: 'text'
  })
  return response.data
}

export const updateLessonFile = async (lessonKey, file, lessonName, etag, fileDisplayName, isAbsorbCourse, absorbCourseId, passingScore, content = null) => {
  if (file) {
    if (file.size > MAX_FILE_SIZE) {
      throw new Error(`File size exceeds maximum of ${MAX_FILE_SIZE / (1024 * 1024)} MB`)
    }
    
    if (!file.name.toLowerCase().endsWith('.md')) {
      throw new Error('Only .md files are allowed')
    }
  }
  
  if (!etag) {
    throw new Error('ETag is required for updates. Please refresh the lesson list and try again.')
  }
  
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  if (content) {
    formData.append('content', content)
  }
  if (lessonName) {
    formData.append('lessonName', lessonName)
  }
  if (fileDisplayName) {
    formData.append('fileDisplayName', fileDisplayName)
  }
  if (isAbsorbCourse !== undefined) {
    formData.append('isAbsorbCourse', isAbsorbCourse)
  }
  if (isAbsorbCourse && absorbCourseId) {
    formData.append('absorbCourseId', absorbCourseId)
  }
  if (isAbsorbCourse && passingScore !== undefined && passingScore !== null) {
    formData.append('passingScore', passingScore)
  }
  
  const response = await api.post(`/api/lessons/${lessonKey}/file`, formData, {
    headers: {
      'If-Match': etag
    }
  })
  
  return response.data
}

export const deleteLesson = async (lessonKey, etag) => {
  const url = `/api/lessons/${lessonKey}`
  const config = {
    headers: {}
  }
  
  if (etag) {
    config.headers['If-Match'] = etag
  }
  
  try {
    const response = await api.delete(url, config)
    return response
  } catch (error) {
    // Log the error for debugging
    console.error('Delete lesson error:', error)
    console.error('URL:', url)
    console.error('Config:', config)
    throw error
  }
}


